import { render, staticRenderFns } from "./indexB.vue?vue&type=template&id=00af1908&scoped=true"
import script from "./indexB.vue?vue&type=script&lang=js"
export * from "./indexB.vue?vue&type=script&lang=js"
import style0 from "./indexB.vue?vue&type=style&index=0&id=00af1908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00af1908",
  null
  
)

export default component.exports